import { useState } from "react";
import { Button } from "antd";
import { ShareAltOutlined } from "@ant-design/icons";

import { ShareProjectModal } from "./ShareProjectModal";

function ShareBtn() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button icon={<ShareAltOutlined />} onClick={() => setOpen(true)} />
      <ShareProjectModal open={open} setOpen={setOpen} />
    </>
  );
}

export { ShareBtn };
